import { MarketConquestFilterType } from '../../enums/MarketConquestFilterType';
import { Action } from '../../types/Action';
import { FilterItemResource, MinMaxFilter } from '../../types/FilterTypes';
import { FilterType, SelectedFilterResource } from '../../types/MarketConquestFilterResource';
import { MarketConquestRequestResource } from '../../types/MarketConquestRequestResource';
import { OpportunityMapResource } from '../../types/OpportunityMapResource';

export enum MarketConquestActionsType {
  SET_DASHBOARD_FILTERS = 'Set dashboard filters',
  SET_SELECTED_FILTERS = 'Set selected filters',
  SET_MASTER_FILTER = 'Set Master Filter',
  SET_IS_FILTERS_CHANGED = 'Set is filter changed',
  SET_ASSIGNEE_USERS = 'Set assignee users',
  SET_DEFAULT_LAST_UPDATED = 'Set default last updated',
  SET_MARKET_CONQUEST_REQUEST_RESOURCE = 'Set market conquest request resource',
  SET_DASHBOARD_DATA_TOTAL_COUNT = 'Set dashboard data total count',
  SET_SHOULD_REFRESH = 'Should refresh',
  SET_IS_LOADING = 'Set is loading',
  SET_HAS_INVENTORY_ACQUISITION = 'Set has inventory acquisition',
  SET_IS_FILTERS_SHOWING = 'Set is filters showing',
  SET_IS_MAP_LOADING = 'Set is map loading',
  SET_IS_MAP_ERROR = 'Set is map error',
  SET_MAP_DATA = 'Set map data',
  SET_MAP_CONFIG = 'Set map config',
  SET_SELECTED_DEALER = 'Set selected dealer for map',
  SET_DROPDOWN_SELECTED_ZIPS = 'Set dropdown selected zips',
  SET_DROPDOWN_SELECTED_AUDIENCE = 'Set dropdown selected audience',
}

export const setDashboardFilters = (filters: FilterType): Action => ({
  type: MarketConquestActionsType.SET_DASHBOARD_FILTERS,
  payload: filters,
});

export const updateSelectedFilters = (filters: SelectedFilterResource): Action => ({
  type: MarketConquestActionsType.SET_SELECTED_FILTERS,
  payload: filters,
});

export const updateMasterFilterKey = (key: MarketConquestFilterType): Action => ({
  type: MarketConquestActionsType.SET_MASTER_FILTER,
  payload: key,
});

export const setIsFiltersChanged = (value: boolean): Action => ({
  type: MarketConquestActionsType.SET_IS_FILTERS_CHANGED,
  payload: value,
});

export const setDefaultLastUpdated = (value: MinMaxFilter<number>): Action => ({
  type: MarketConquestActionsType.SET_DEFAULT_LAST_UPDATED,
  payload: value,
});

export const setMarketConquestRequestResource = (
  requestBody: MarketConquestRequestResource,
): Action => ({
  type: MarketConquestActionsType.SET_MARKET_CONQUEST_REQUEST_RESOURCE,
  payload: requestBody,
});

export const setDashboardDataTotalCount = (value: number): Action => ({
  type: MarketConquestActionsType.SET_DASHBOARD_DATA_TOTAL_COUNT,
  payload: value,
});

export const setShouldRefresh = (value: boolean): Action => ({
  type: MarketConquestActionsType.SET_SHOULD_REFRESH,
  payload: value,
});

export const setIsLoading = (value: boolean): Action => ({
  type: MarketConquestActionsType.SET_IS_LOADING,
  payload: value,
});

export const setHasInventoryAcquisition = (value?: boolean): Action => ({
  type: MarketConquestActionsType.SET_HAS_INVENTORY_ACQUISITION,
  payload: value,
});

export const setIsFiltersShowing = (value: boolean): Action => ({
  type: MarketConquestActionsType.SET_IS_FILTERS_SHOWING,
  payload: value,
});

export const setIsMapLoading = (value: boolean): Action => ({
  type: MarketConquestActionsType.SET_IS_MAP_LOADING,
  payload: value,
});

export const setIsMapError = (value: boolean): Action => ({
  type: MarketConquestActionsType.SET_IS_MAP_ERROR,
  payload: value,
});

export const setDropdownSelectedZips = (value: FilterItemResource[]): Action => ({
  type: MarketConquestActionsType.SET_DROPDOWN_SELECTED_ZIPS,
  payload: value,
});

export const setMapData = (value: OpportunityMapResource): Action => ({
  type: MarketConquestActionsType.SET_MAP_DATA,
  payload: value,
});

export const setMapConfig = (value: google.maps.MapOptions): Action => ({
  type: MarketConquestActionsType.SET_MAP_CONFIG,
  payload: value,
});

export const setMapSelectedDealer = (value: string): Action => ({
  type: MarketConquestActionsType.SET_SELECTED_DEALER,
  payload: value,
});

export const setDropdownSelectedAudience = (value: string): Action => ({
  type: MarketConquestActionsType.SET_DROPDOWN_SELECTED_AUDIENCE,
  payload: value,
});

export type MarketConquestActions = ReturnType<
  | typeof setDashboardFilters
  | typeof updateMasterFilterKey
  | typeof setIsFiltersChanged
  | typeof updateSelectedFilters
  | typeof setDefaultLastUpdated
  | typeof setMarketConquestRequestResource
  | typeof setDashboardDataTotalCount
  | typeof setShouldRefresh
  | typeof setIsLoading
  | typeof setHasInventoryAcquisition
  | typeof setIsFiltersShowing
  | typeof setIsMapLoading
  | typeof setIsMapError
  | typeof setMapData
  | typeof setMapConfig
  | typeof setMapSelectedDealer
  | typeof setDropdownSelectedAudience
>;
